import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "200px",
    width: "100%",
    overflowX: "auto",
    borderRadius: "0",
    paddingLeft: 16,
    paddingRight: 16,
  },
  img: {
    width: "60px",
    height: "60px",
    margin: "0 0 12px",
    color: theme.palette.primary.main,
  },
  text: {
    textAlign: 'center',
  },
}));
